import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import savedShoppingCartTemplate from '../templates/saved-shopping-carts-template';
import ApiManager from '../../api/crud-manager';

class SaveShoppingCart {
  constructor(options = {}) {
    this.config = {
      saveModule: () => document.querySelectorAll('[data-module="saveShoppingCartForm"]'),
      displayModule: () => document.querySelector('[data-module="savedShoppingCarts"]'), // element to dispaly list of all stored shopping carts
      cartId: Cookies.get('cartId'),
      ...options
    };
    this.apiManager = new ApiManager();
  }

  init() {
    const { displayModule, saveModule } = this.config;

    if (saveModule()) {
      saveModule().forEach(el =>
        el.addEventListener('submit', event => this.saveCart(event), true)
      );
    }

    if (displayModule()) {
      this.displayCarts(displayModule());
    }
  }

  getCarts() {
    return this.apiManager.get('/api/v2/preference/user/?key=savedCarts').then(response => {
      // No user preferences
      if (!response.length) {
        return null;
      }

      // No data
      if (!response[0].value) {
        return [];
      }

      return JSON.parse(decodeURI(response[0].value));
    });
  }

  setCart(event) {
    const element = event.target;
    const { cartId } = element.dataset;

    // set new cookie and local storage of cart
    localStorage.setItem('cartId', cartId);
    Cookies.set('cartId', cartId);

    this.deleteCartById(cartId, () => window.location.assign('/winkelwagen'));
  }

  deleteCart(event) {
    const element = event.target;
    const { cartId } = element.dataset;

    this.deleteCartById(cartId, () => window.location.reload());
  }

  saveCart(event) {
    event.preventDefault();
    const form = event.target;
    const cartName = form.querySelector('[name="cartName"]').value;

    if (!cartName) return;

    this.getCarts().then(savedCarts => {
      const cartId = Cookies.get('cartId');
      const currentCart = {
        cartName,
        cartId,
        cartDate: SaveShoppingCart.getCurrentDate()
      };

      if (savedCarts != null) {
        if (SaveShoppingCart.containsCartId(currentCart, savedCarts)) {
          const alertHtml = `<div class="alert alert-info alert-dismissible" role="alert">Huidige winkelwagen is al opgeslagen in mijn projecten. <a href="/mijn-account/mijn-projecten">Bekijk project</a></div>`;
          const submitButton = form.querySelector('[type="submit"]');
          form.insertAdjacentHTML('afterbegin', alertHtml);
          submitButton.setAttribute('disabled', 'disabled');
          return; // if cart already in saved carts skip rest of function
        }
        savedCarts.push(currentCart);
        const json = encodeURI(JSON.stringify(savedCarts));
        const patchValue = JSON.parse(`[{"op":"replace","path":"/value","value":"${json}"}]`);
        this.apiManager
          .patch('/api/v2/preference/user/savedCarts', patchValue)
          .then(response => response)
          .then(() => {
            Cookies.set('cartId', uuidv4()); // create new cart
            window.location.href = '/mijn-account/mijn-projecten'; // redirect to my projects page
          });
      } else {
        const json = encodeURI(JSON.stringify([currentCart]));
        const postValue = JSON.parse(`{"key":"savedCarts","value":"${json}","type":"string"}`);
        this.apiManager
          .post('/api/v2/preference/user', postValue)
          .then(response => response)
          .then(() => {
            // Cookies.set('cartId', uuidv4(), null, '/'); // create new cart
            Cookies.set('cartId', uuidv4()); // create new cart
            window.location.href = '/mijn-account/mijn-projecten'; // redirect to my projects page
          });
      }
    });
  }

  displayCarts(element) {
    element.classList.add('is-loading');
    const resultsDiv = element.querySelector('[data-results]');
    const { noPrices } = resultsDiv.dataset;
    const noPrice = noPrices.toLowerCase() === 'true';

    this.getCarts().then(savedCarts => {
      if (savedCarts != null && savedCarts.length) {
        const apiResult = [];
        let awaitCounter = 0;

        // order array by cartname ASC
        savedCarts.sort((a, b) => {
          const cartA = a.cartName.toLowerCase();
          const cartB = b.cartName.toLowerCase();
          if (cartA < cartB)
            // sort string ascending
            return -1;
          if (cartA > cartB) return 1;
          return 0; // default return value (no sorting)
        });

        savedCarts.forEach((cart, index) => {
          const { cartId, cartDate, cartName } = cart;
          const token = Cookies.get('token');

          fetch(`/api/v1/catalog/cart/${cartId}`, {
            headers: {
              'Accept-Language': 'nl',
              Authorization: `bearer ${token}`
            }
          })
            .then(response => response.json())
            .then(data => {
              // because the values must be displayed in alphabetical order, an array is first created and when all fetch values are back that print the array
              apiResult[index] = savedShoppingCartTemplate(data, cartName, cartDate, noPrice);
              awaitCounter += 1; // add 1 to counter if result is fetched

              if (awaitCounter === savedCarts.length) {
                apiResult.forEach(result => {
                  resultsDiv.insertAdjacentHTML('beforeend', result);
                });
                element.classList.remove('is-loading');
                element.querySelectorAll('[data-module="appendCart"]').forEach(button => {
                  button.addEventListener('click', event => this.setCart(event), true);
                });
                element.querySelectorAll('[data-module="deleteCart"]').forEach(button => {
                  button.addEventListener('click', event => this.deleteCart(event), true);
                });
              }
            })
            .catch(() => {
              awaitCounter += 1; // ignore api errors
              if (savedCarts.length === awaitCounter) {
                element.classList.remove('is-loading');
                resultsDiv.insertAdjacentHTML(
                  'beforeend',
                  `<p>Je hebt nog geen opgeslagen projecten.</p>`
                );
              }
            });
        });
      } else {
        element.classList.remove('is-loading');
        element.insertAdjacentHTML('beforeend', `<p>Je hebt nog geen opgeslagen projecten.</p>`);
      }
    });
  }

  deleteCartById(cartId, callback) {
    this.getCarts().then(savedCarts => {
      savedCarts.forEach((cart, index) => {
        if (cart.cartId === cartId) {
          savedCarts.splice(index, 1);
        }
      });
      const json = encodeURI(JSON.stringify(savedCarts));
      const patchValue = JSON.parse(`[{"op": "replace","path": "/value","value": "${json}"}]`);
      return this.apiManager
        .patch('/api/v2/preference/user/savedCarts', patchValue)
        .then(response => response)
        .then(() => {
          callback();
        });
    });
  }

  // helper functions
  // make date to display 'name day (01-01-1990)'
  static getCurrentDate() {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; // Januari is 0!

    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    today = `${dd}-${mm}-${yyyy}`;

    return `${today}`;
  }

  // function to loop through the saved shopping cart and see if the current shopping cart already exists.
  static containsCartId(obj, list) {
    let found = false;
    for (let i = 0; i < list.length; i += 1) {
      if (list[i].cartId === obj.cartId) {
        found = true;
        break;
      }
    }
    return found;
  }
}

export default SaveShoppingCart;
